<div class="category-scroll-container">
  <button class="scroll-control prev" (click)="scroll('left')" *ngIf="showLeftArrow">
    <span class="arrow left"></span>
  </button>

  <div class="scroll-wrapper" #scrollContainer (scroll)="onScroll()">
    <div 
      *ngFor="let cat of categorias" 
      class="category-item" 
      [class.active]="categoriaSeleccionada === cat.categoria"
      (click)="selectCategory(cat)"
    >
      <div class="icon-container">
        <img [src]="cat.imagen || 'assets/icons/default-category.svg'" [alt]="cat.nombre">
      </div>
      <span class="category-name">{{ cat.nombre }}</span>
    </div>
  </div>

  <button class="scroll-control next" (click)="scroll('right')" *ngIf="showRightArrow">
    <span class="arrow right"></span>
  </button>
</div>
